import Head from "next/head";
import ExplorerPage from "../src/explorer/ExplorerPage.tsx";
import { lastPatch } from "common/src/Config.ts";

export default function Player() {
  return <ExplorerPage />;
}
